<template lang="pug">
#wrap
  .container(v-show="showPageList")
    .left
      .operBtn
        el-button(type="text" size="small" icon="el-icon-plus" @click="handleAddGroup") 添加模块
        el-button(type="text" size="small" icon="el-icon-plus" @click="handleAdd") 添加应用
        el-input(v-model="searchModuleVal" size="small" style="width: 240px" placeholder="请输入模块名进行搜索" prefix-icon="el-icon-search")
      draggable(v-model="moduleList" :options="{ group: 'people', handle: '.handleDragger .my-handle' }" class="dragArea" :move="dragMove" @end="dragEnd")
        .element(v-for="(element, index) in moduleList"
          :key="element.appCode"
          :class="index > 0 ? 'handleDragger' : ''"
          :style="curGroupId === element.appCode ? 'background-color: #eee;' : ''"
          @click="handleLiClick(element)")
          div
            i(class="iconfont icon-drag drag-option my-handle" style="cursor: pointer; margin-right: 10px")
            span {{ element.appName }}
            span(style="margin-left: 20px") {{ element.children.length }}
          .icon
            i(class="el-icon-edit-outline tubiao" title="编辑" @click.stop="openDialogGroup(element)")
            i(class="el-icon-delete tubiao" title="删除" @click.stop="deleteGrouping(element)")
    .right
      el-row(style="padding: 0 0 var(--middle-space) 0")
        el-input(v-model="searchVal" size="small" style="width: 240px; margin-right: 20px" placeholder="请输入应用名或应用编号进行搜索" prefix-icon="el-icon-search")
        el-button(type="text" icon="el-icon-edit" :disabled="!selectList.length" size="small" @click="handleChangeGroup") 调整分组
      el-table(:data="tableData"
        element-loading-text="数据加载中"
        style="width: 100%"
        align="center"
        height="100%"
        border
        @select="handleSelect"
        @select-all="handleSelectAll")
        template(slot="empty")
          img(:src="zanwu")
          p(style="font-size: 16px; color: #000; margin-top: 36px") 暂无消息
        el-table-column(align="center" type="selection" width="55")
        el-table-column(align="center" width="60" )
          i.iconfont.icon-drag.drag-option.my-handle(style="cursor: pointer")
        el-table-column(align="center" prop="appName" label="应用名称" v-slot="{row}")
          el-link(type="primary" @click="handleEdit(row)")
            span.tabLinkSpan(style="cursor: pointer" :title="row.appName") {{ row.appName }}
        el-table-column(align="center" prop="appCode" label="应用编号")
        el-table-column(align="center" prop="category" label="所属分类")
          span {{curGroup.appName}}
        el-table-column(align="center" prop="status" label="发布状态" v-slot="{row}")
          span {{ row.status == 0 ? "禁用" : "启用" }}
        el-table-column(align="center" prop="createUserName" label="创建人")
        el-table-column(align="center" prop="operDate" label="创建时间")
        el-table-column(align="center" label="操作" min-width="120px" v-slot="{row}")
          el-button(type="text" @click="handleAppSettings(row)") 应用设计
          el-button(type="text" @click="handleEdit(row)") 编辑
          el-button(type="text" @click="handleDelete(row)") 删除
    el-dialog(:title="dialogVisibleTil" :visible.sync="dialogVisible" width="500px" :before-close="handleClose")
      el-form(ref="form" :model="form" size="small")
        el-form-item(label="应用名称" prop="appName" :rules="[{ required: true, message: '请输入应用名称', trigger: 'blur' }]")
          el-input(v-model="form.appName")
        el-form-item(label="跳转路由地址" prop="targetUrl" :rules="[{ required: true, validator: validatePass, trigger: 'blur' }]")
          el-input(v-model="form.targetUrl")
            template(slot="prepend") /application-
          span 提示：只能包含字母、数字、下划线（_）
        el-form-item(label="分组" prop="group" :rules="[{ required: true, message: '请选择分组', trigger: 'change' }]")
          el-select(v-model="form.group" placeholder="请选择" style="width: 100%")
            el-option(v-for="item in list" :key="item.appCode" :label="item.appName" :value="item.appCode")
        el-form-item(label="应用描述" prop="description" :label-width="formLabelWidth")
          el-input(v-model="form.description" type="textarea")
        el-form-item(label="应用图标" :label-width="formLabelWidth")
          el-upload(
            :action="action"
            :headers="headers"
            :show-file-list="true"
            :accept="accept"
            list-type="picture-card"
            :before-upload="beforeUpload"
            :http-request="(e) => uploadIconHandler(e, 'activeIconBase64')"
            :on-success="(response, file, fileList) => iconUploadSuccess(response, file, fileList, 'activeIconBase64')"
            :on-exceed="onExceed"
            :file-list="activeIconList"
            :auto-upload="true"
            :limit="1"
            disabled )
            i.el-icon-plus
      span.dialog-footer(slot="footer")
        el-button(size="small" @click="dialogVisible = false") 取 消
        el-button(type="primary" size="small" @click="dialogVisibleConfirm") 确 定
    el-dialog(title="新建模块" :visible.sync="addGroupDialogVisible" width="500px" :before-close="handleClose")
      el-form(:model="addGroupForm" size="small")
        el-form-item(required label="模块名称" :label-width="formLabelWidth")
          el-input(v-model="addGroupForm.groupName")
      span.dialog-footer(slot="footer")
        el-button(size="small" @click="addGroupDialogVisible = false") 取 消
        el-button(type="primary" size="small" @click="addGroupDialogConfirm") 确 定
    el-dialog(title="调整模块" :visible.sync="changeGroupDialogVisible" width="500px" :before-close="handleClose")
      el-form(:model="changeGroupForm" size="small")
        el-form-item(label="新模块" :label-width="formLabelWidth")
          el-select(v-model="changeGroupForm.newGroup" placeholder="请选择新分组" style="width:100%")
            el-option(v-for="item in groups" :key="item.appCode" :label="item.appName" :value="item.appCode")
      span.dialog-footer(slot="footer")
        el-button(size="small" @click="changeGroupDialogVisible = false") 取 消
        el-button(type="primary" size="small" @click="changeGroupDialogConfirm") 确 定
    el-dialog(title="修改名称" :visible.sync="renameDialogVisible" width="500px" :before-close="handleClose")
        el-form(:model="renameForm")
          el-form-item(label="新名称" required :label-width="formLabelWidth")
            el-input(v-model="renameForm.newName")
        span(slot="footer" class="dialog-footer")
          el-button(@click="renameDialogVisible = false") 取 消
          el-button(type="primary" @click="renameDialogConfirm") 确 定
  appMeunSettings(v-if="!showPageList" :appInfo="curApp" @backPage="handleBack")
</template>

<script>
function Form() {
  return {
    appName: "",
    routerName: "",
    targetUrl: "",
    group: "",
    description: "",
    imageUrl: "",
    activeIconBase64: "",
    permissionId: ""
  };
}
import draggable from "vuedraggable";
import Sortable from "sortablejs";
import applicationSettingsService from "@/CommonDP/service/applicationSettings-service";
import appMeunSettings from "./appMeunSettings.vue";
import { getToken, uploadDataUrl } from "@/CommonDP/utils";
import { browserFileToBase64 } from "@/CommonDP/utils/browserFile";
import resourceService from "@/CommonDP/service/admin/resources-service";
import { getter } from "@/CommonDP/utils/commonRender/utils";

export default {
  name: "ApplicationSettings",
  components: {
    draggable,
    appMeunSettings
  },
  data() {
    return {
      changeGroupDialogVisible: false,
      changeGroupForm: {
        newGroup: ""
      },
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      formLabelWidth: "auto",
      list: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        totalCount: 10
      },
      pageLayout: "->, total,sizes, prev, pager, next,jumper",
      dialogVisible: false,
      form: new Form(),
      renameDialogVisible: false,
      renameForm: {
        newName: "",
        _curGroup: {}
      },
      addGroupDialogVisible: false,
      addGroupForm: {
        groupName: ""
      },
      curGroup: {},
      curApp: {},
      searchVal: "",
      searchModuleVal: "",
      selectList: [],
      dialogVisibleTil: "新增",
      showPageList: true,
      // eslint-disable-next-line
      _sortable: null,
      // 图标上传
      action: "",
      headers: {
        Authorization: "Bearer " + getToken()
      },
      accept: "image/png"
    };
  },
  computed: {
    groups() {
      return this.list.filter((item) => item.appCode !== this.curGroupId);
    },
    curGroupId() {
      return this?.curGroup?.appCode || "";
    },
    tableData() {
      if (this.searchVal) {
        return this.curGroup.children.filter((child) => child.appCode.includes(this.searchVal) || child.appName.includes(this.searchVal));
      } else {
        return this.curGroup?.children || [];
      }
    },
    moduleList: {
      get() {
        if (this.searchModuleVal) {
          return this.list.filter((child) => child.appName.includes(this.searchModuleVal));
        } else {
          return this.list;
        }
      },
      set(val) {
        this.list = val;
      }
    },
    // 应用图标
    activeIconList() {
      if (!this.form.activeIconBase64) return [];
      return [{ name: "active", url: this.getActiveIconUrl() }];
    }
  },

  watch: {
    curGroup() {
      if (this._sortable) {
        this._sortable.option("disabled", this.curGroup?.appCode === null);
      }
    }
  },

  created() {
    this.getAppList();
  },

  mounted() {
    this.rowDrop();
    this.action = uploadDataUrl();
  },

  methods: {
    getAppList() {
      // 这里是获取list的逻辑
      applicationSettingsService.getAppList().then((response) => {
        this.list = response.data;
        if (this.curGroup?.appCode) {
          this.curGroup = this.list.find((item) => item.appCode === this.curGroup.appCode) || {};
        } else {
          this.curGroup = this.list.find((item) => !item.appCode) || {};
        }
      });
    },
    handleBack() {
      this.showPageList = true;
    },
    handleAppSettings(data) {
      this.curApp = data;
      this.showPageList = false;
    },
    rowDrop() {
      // 此时找到的元素是要拖拽元素的父容器
      const dom = document.querySelector(".el-table__body-wrapper tbody");
      this._sortable = Sortable.create(dom, {
        handle: ".my-handle",
        onEnd: (e) => {
          const curGroupId = this.tableData[e.oldIndex].appCode;
          applicationSettingsService.updateAppOrder(curGroupId, e.newIndex + 1);
        }
      });
    },
    dragEnd(e) {
      const curGroupId = this.list[e.newIndex].appCode;
      applicationSettingsService.updateAppOrder(curGroupId, e.newIndex).then(() => {
        this.getAppList();
      });
    },
    dragMove(e) {
      console.log(e.relatedContext.element.appCode);
      // null代表全部，全部默认第一个不可更改, 搜索状态也不可更改
      if (e.relatedContext.element.appCode === null || this.searchModuleVal) {
        return false;
      }
      return true;
    },
    dialogVisibleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const { activeIconBase64 } = this.form;
          if (this.dialogVisibleTil === "新增") {
            applicationSettingsService
              .addApp({
                type: 1,
                appName: this.form.appName,
                routerName: `application-${this.form.targetUrl}`,
                targetUrl: `/application-${this.form.targetUrl}`,
                notes: this.form.description,
                parentAppCode: this.curGroup.appCode,
                activeIconBase64
              })
              .then((response) => {
                this.$message({
                  type: "success",
                  message: "添加成功"
                });
                this.dialogVisible = false;
                this.form = new Form();
                this.getAppList(); // 重新获取应用列表
              });
          } else {
            applicationSettingsService
              .updateAppName(this.form._appCode, {
                type: 1,
                appName: this.form.appName,
                routerName: `application-${this.form.routerName}`,
                targetUrl: `/application-${this.form.targetUrl}`,
                notes: this.form.description,
                parentAppCode: this.curGroup.appCode || this.form.group,
                activeIconBase64
              })
              .then((response) => {
                this.$message({
                  type: "success",
                  message: "编辑成功"
                });
                this.dialogVisible = false;
                this.form = new Form();
                this.getAppList(); // 重新获取应用列表
              });
          }
        } else {
          return false;
        }
      });
    },

    handleSearch(val) {
      // 这里是搜索的处理逻辑
      this.searchVal = val;
    },
    changeGroupDialogConfirm() {
      // 这里是确认调整分组的处理逻辑
      if (this.changeGroupForm.newGroup === "") {
        this.$message({
          type: "warning",
          message: "新分组不能为空"
        });
        return;
      }
      applicationSettingsService
        .changeGroup(
          this.changeGroupForm.newGroup,
          this.selectList.map((item) => item.appCode)
        )
        .then((response) => {
          this.$message({
            type: "success",
            message: "调整成功"
          });
          this.changeGroupDialogVisible = false;
          this.changeGroupForm.newGroup = "";
          this.getAppList(); // 重新获取分组列表
        });
    },

    renameDialogConfirm() {
      // 调用重命名接口
      applicationSettingsService
        .updateAppName(this.renameForm._curGroup.appCode, {
          appName: this.renameForm.newName,
          type: 0
        })
        .then((response) => {
          this.$message({
            type: "success",
            message: "重命名成功"
          });
          this.renameDialogVisible = false;
          this.renameForm.newName = "";
          this.renameForm._curGroup = {};
          this.getAppList(); // 重新获取应用列表
        });
    },

    handleSelect(val) {
      this.selectList = val;
    },
    handleSelectAll() {
      this.selectList = this.tableData;
    },
    handleAddGroup() {
      // 这里是添加分组的处理逻辑
      this.addGroupDialogVisible = true;
    },

    addGroupDialogConfirm() {
      // 这里是确认添加分组的处理逻辑
      if (this.addGroupForm.groupName === "") {
        this.$message({
          type: "warning",
          message: "分组名称不能为空"
        });
        return;
      }
      applicationSettingsService
        .addApp({
          type: 0,
          appName: this.addGroupForm.groupName
        })
        .then((response) => {
          this.$message({
            type: "success",
            message: "添加成功"
          });
          this.addGroupDialogVisible = false;
          this.addGroupForm.groupName = "";
          this.getAppList(); // 重新获取分组列表
        });
    },

    handleLiClick(element) {
      // 这里是更新tableData和curGroupId的逻辑
      this.curGroup = element;
      this.selectList = [];
    },

    handleClose() {
      this.renameDialogVisible = false;
      this.addGroupDialogVisible = false;
      this.dialogVisibleTil = false;
      this.changeGroupDialogVisible = false;
      this.dialogVisible = false;
    },

    async handleEdit(data) {
      this.dialogVisible = true;
      this.form.appName = data.appName;
      this.form.routerName = data.routerName.replace(/application-/g, "");
      this.form.targetUrl = data.targetUrl.replace(/\/application-/g, "");
      this.form.group = data.parentAppCode;
      this.form.description = data.notes;
      this.form._appCode = data.appCode;
      this.dialogVisibleTil = "编辑";
      this.form.permissionId = data.permissionId;
      const res = await resourceService.getResourceIcon(data.permissionId);
      if (res.data) {
        this.form.activeIconBase64 = res.data.activeIconBase64;
      }
    },
    async handleDelete(isSingleRow, row) {
      await this.$confirm("警告，删除的数据将无法恢复！确认继续删除应用吗？", "提示", { type: "warning" });
      let ids = "";
      if (isSingleRow) {
        ids = row.appCode;
      } else {
        ids = this.selectList.map((item) => item.appCode).join(",");
      }
      console.log(
        row,
        ids,
        this.selectList,
        this.selectList.map((item) => item.appCode)
      );
      applicationSettingsService.deleteApp(ids).then((response) => {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.getAppList();
      });
    },
    handleAdd() {
      this.dialogVisible = true;
      this.form = new Form();
      this.form.group = this.curGroup.appCode;
      this.dialogVisibleTil = "新增";
    },
    handleChangeGroup() {
      // 这里是调整分组的处理逻辑
      this.changeGroupDialogVisible = true;
    },

    openDialogGroup(data) {
      this.renameDialogVisible = true;
      this.renameForm.newName = data.appName;
      this.renameForm._curGroup = data;
    },
    async deleteGrouping(data) {
      if (data?.children.length > 0) {
        return this.$warn("该分组下还有应用,请先删除应用!");
      }
      await this.$confirm("确认删除?", "不会删除该分组下的应用，这些应用将出现在未分组应用中。", { type: "warning" });
      applicationSettingsService.deleteApp(data.appCode).then((response) => {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.getAppList(); // 重新获取应用列表
      });
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    },
    // 上传图标
    beforeUpload(file) {
      if (file.size > 1024 * 2) {
        this.$warn("图标大小不能超过 2KB");
        return false;
      }
      return true;
    },
    uploadIconHandler(e, key) {
      browserFileToBase64(e.file).then((res) => {
        this.form[key] = res;
      });
    },
    iconUploadSuccess(response, file, fileList, key) {
      this.form[key] = response.data.fileKey;
    },
    onExceed(f) {
      this.$warn("只能上传一个图标 2KB");
    },
    // 应用图标url
    getActiveIconUrl() {
      if (this.form.activeIconBase64) {
        return this.form.activeIconBase64;
      }
      return resourceService.getResourceActiveIconUrl(this.form.permissionId);
    },
    validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入路由地址"));
      } else if (!/^[a-zA-Z0-9_]*$/.test(value)) {
        callback(new Error("请输入正确的路由地址"));
      } else {
        callback();
      }
    }
  }
};
</script>

<style lang="less" scoped>
#wrap {
  height: 100%;
  overflow-y: auto;
  .operation {
    color: #4777e7;
    margin: 0 3px;
    cursor: pointer;
  }
}

.container {
  height: 100%;
  overflow-y: auto;
  display: flex;
}

.left {
  width: 350px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .operBtn {
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    // justify-content: center;
  }
}

.right {
  flex: 1;
  padding: var(--middle-space) var(--big-space);
  display: flex;
  flex-direction: column;

  .el-table {
    flex: 1;
  }
}

.icon {
  margin-left: auto;
  font-size: 16px;

  i {
    margin-left: 5px;
  }
}

.element {
  background-color: #f6f6f6;
  margin: 10px;
  border: 1px solid #f2f2f2;
  border-radius: 5px;
  padding: 0 10px;
  display: flex;
  padding: 0 10px;
  justify-content: space-between;
}

.dragArea {
  width: 100%;
  height: 1px;
  flex: 1 0 1px;
  line-height: 38px;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: var(--middle-space) var(--big-space);
  box-sizing: border-box;
  overflow: hidden;
  &:hover {
    overflow: overlay !important;
    overflow: auto;
  }
}
</style>
